<template>
    <v-dialog
        v-model="dialogStatus"
        max-width="860"
    >
        <v-card>
            <v-card-title class="headline">
                ¿Estás seguro de que quieres {{ titleActive }} {{ settingDescripction }}?
            </v-card-title>
            <v-card-text
                class="headline"
                color="red"
                v-if="hasSubtitle"
            >
                {{ subtitle }}
            </v-card-text>
            <v-card-text
                v-if="hasEmails"
            >
                <v-col
                cols="12"
                >
                <v-text-field
                    v-model="ccEmails"
                    label="CC. Correo Electrónico"
                    placeholder="ejemplo@dominio.com"
                    required
                />
                </v-col>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="error darken-1"
                    text
                    @click="$emit('closeModal', false)"
                    >
                    Cancelar
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    :loading="loading"
                    @click.prevent="acceptModal"
                >
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialogStatus: {
            default: false,
            required: true,
        },
        active: {
            default: false,
            required: true,
        },
        settingDescripction: {
            required: true,
        },
        name: {
            default: '',
            required: false,
        },
        loading: {
            default: false,
            required: true,
        },
        methodToggle: {
            required: true,
        },
        hasSubtitle: {
            required: false,
            default: false,
        },
        subtitle: {
            required: false,
            default: '',
        },
        hasEmails: {
            required: false,
            default: false,
        },
    },
    computed: {
        titleActive() {
            if (this.active) {
                return 'desactivar';
            }
            return 'activar';
        },
    },
    data: () => ({
        ccEmails: '',
    }),
    methods: {
        acceptModal() {
            if (this.hasEmails) {
                this.$emit('changeCCMails', this.ccEmails);
                this.ccEmails = '';
            }
            this.methodToggle();
        },
    },
};
</script>

<style>

</style>
